module.exports = __webpack_public_path__ + "static/base.20c86131.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/resources/images/tower/base.png
// module id = 248
// module chunks = 0